import React, { useEffect } from 'react';
import MetaTags from 'react-meta-tags';
import { Typography } from '@mui/material';
import { Box } from '@material-ui/core';
import { successToast } from '../../../components/Toasts';
import { ToastContainer } from 'react-toastify';
const Layout2 = props => {
  console.log(props, 'props');
  useEffect(() => {
    if (props?.location?.state?.loggedIn) {
      setTimeout(() => {
        successToast('Welcome Back Admin.');
      }, 1000);
    }
  }, []);
  return (
    <React.Fragment>
      <ToastContainer
        position='top-center'
        autoClose={5800}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <MetaTags>
        <title>Admin TMS </title>
      </MetaTags>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '90%'
        }}
      >
        <Typography variant='h3'>Admin Dashboard </Typography>
      </Box>
    </React.Fragment>
  );
};
export default Layout2;
